import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { track } from '../../helpers';
import Metric from '../metric';

const renderMetrics = (metrics) => {
  return metrics.map(metric => {
    return <Metric key={metric.id} {...metric} />
  })
};

const onSignUpClick = () => {
  track('Start Free Trial', 'conversion');
};

const ResultPage = ({ metrics }) => {
  if (!metrics || metrics.length === 0) {
    return <div>No metrics for these tags. Should we redirect to home?</div>;
  }

  const styleInner = {
    margin: "auto",
  };

  return (
    <div className="w-90-l w-100 tc pa3" style={styleInner}>

      <h3 className="light-blue-gray o-50 ttu f5 fw7 tracked">Results</h3>
      <h2 className="center dark-blue-gray f1-ns f2 fw9 tracked-tight mt0 mb3 lh-tight">The metrics to start tracking</h2>
      <h3 className=" center light-blue-gray fw3 f3-ns f4  lh-title mb4 mw7">Perfecting metrics is an iterative process. Based on what you’ve told us these metrics are a good starting point. However, remember to refine them as you learn more about what’s working!
      </h3>
      <div className="flex flex-wrap flex-row items-start justify-center">
        {renderMetrics(metrics)}
      </div>
      <div className="mt4 bg-light-blue-gray mw7 center pv4-ns pv2 ph5-ns ph3">
        <h3 className="fw9 tracked-tight dark-blue-gray f2-ns f3 mb4-ns mb3"><span className="light-blue-gray ">Ready to start tracking these metrics?</span> Build a live TV dashboard for your office today.</h3>
        <a onClick={onSignUpClick} href="https://www.geckoboard.com/try-geckoboard/?email=" target="_blank" rel="noopener noreferrer" className="mt0 dib ph5-ns ph4 bg-gecko-green white no-underline fw7 f3-ns f5 br-pill center grow pv3">Start Free Trial</a>
        <p className="light-blue-gray f6 o-50">No credit card required</p>
      </div>
      <Link to="/" className="f6-ns f7 mt5 mb4 dib light-blue-gray o-40 link"> <img src="/back-icon.svg" width={6} alt="Back arrow" className="dib mr2"/>Start again</Link>
    </div>
  );
};

ResultPage.propTypes = {
  metrics: PropTypes.array,
};

export default ResultPage;



// WEBPACK FOOTER //
// ./src/components/result-page/ResultPage.js